import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gift",
  "use": "gift-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"gift\"><path fill=\"none\" fill-rule=\"evenodd\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.6 8v7H2.4V8M1 4.5h14V8H1zM8 15V4.5m0 0H4.85a1.75 1.75 0 0 1 0-3.5C7.3 1 8 4.5 8 4.5zm0 0h3.15a1.75 1.75 0 0 0 0-3.5C8.7 1 8 4.5 8 4.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol